import {
  Box,
  Button,
  Divider,
  Group,
  Loader,
  Modal,
  TextInput,
  Flex,
} from "@mantine/core";
import React, { useState, useMemo } from "react";
import {
  useAddClassesMutation,
  useDeleteClassesMutation,
  useEditClassesMutation,
  useGetClassesQuery,
} from "../../../../redux/features/classeApi";
import ClasseTable from "../../components/ClasseTable";
import { useDisclosure } from "@mantine/hooks";
import EditAction from "../../actions/EditAction";
import AddAction from "../../actions/AddAction";
import DeleteAction from "../../actions/DeleteAction";
import { useForm } from "@mantine/form";
import { DatePickerInput } from "@mantine/dates";

const ClassePage = () => {
  const [query, setQuery] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Formater les dates pour l'API (YYYY-MM-DD)
  const formatDate = (date) => {
    if (!date) return null;
    return date.toISOString().split('T')[0];
  };

  const { data, isLoading } = useGetClassesQuery({
    start_date: formatDate(startDate),
    end_date: formatDate(endDate),
  });

  const [addClasses, { isLoading: addLoading }] = useAddClassesMutation();
  const [editClasses, { isLoading: editLoading }] = useEditClassesMutation();
  const [deleteClasses] = useDeleteClassesMutation();

  const [opened, { open, close }] = useDisclosure(false);
  const [itemEdited, setItemEdited] = useState(null);

  const form = useForm({
    initialValues: {
      name: "",
    },

    validate: {
      name: (value) => (value === "" ? "Ce champ est obligatoire" : null),
    },
  });

  // Filtrer les données par nom uniquement (le filtrage par date est géré par l'API)
  const filteredData = useMemo(() => {
    if (!data?.data) return [];
    return data.data.filter((item) => item?.name.toLowerCase().includes(query));
  }, [data, query]);

  return (
    <Box>
      <Flex justify={"space-between"} align={"center"} mb={20}>
        <TextInput
          placeholder={"Rechercher une classe"}
          onChange={(value) => setQuery(value.target.value.toLowerCase())}
          value={query}
          style={{ flex: 1, maxWidth: 300 }}
        />
        <Group spacing="sm">
          <DatePickerInput
            placeholder="Date début"
            value={startDate}
            onChange={setStartDate}
            clearable
            style={{ minWidth: 140 }}
          />
          <DatePickerInput
            placeholder="Date fin"
            value={endDate}
            onChange={setEndDate}
            clearable
            style={{ minWidth: 140 }}
          />
          <Button onClick={open}>Ajouter</Button>
        </Group>
      </Flex>
      <Divider my={20} />

      {isLoading ? (
        <Loader />
      ) : (
        <Box mb={30}>
          <ClasseTable
            data={filteredData}
            handleEdit={(id, item) => {
              setItemEdited(id);
              form.setValues({
                ...item,
              });
              open();
            }}
            handleDelete={async (id) => await DeleteAction(deleteClasses, id)}
          />
        </Box>
      )}

      {/* My modal */}
      <Modal
        opened={opened}
        onClose={() => {
          close();
          form.reset();
          setItemEdited(null);
        }}
        title={itemEdited ? "Modifier classe" : "Ajouter classe"}
      >
        <form
          onSubmit={form.onSubmit(async (values) => {
            if (itemEdited) {
              await EditAction(editClasses, values);
            } else {
              await AddAction(addClasses, values);
            }
            close();
            form.reset();
          })}
        >
          <TextInput
            label={"Nom de la classe"}
            placeholder={"Nom de la classe"}
            {...form.getInputProps("name")}
          />

          <Divider my={15} />
          <Group position="right">
            <Button color={"gray"} onClick={close}>
              Annuler
            </Button>
            <Button type={"submit"} loading={addLoading || editLoading}>
              {itemEdited ? "Modifier" : "Ajouter"}
            </Button>
          </Group>
        </form>
      </Modal>
    </Box>
  );
};

export default ClassePage;
